import { useEffect, useState } from "react";
import AgentSidebar from "./Commun/AgentSidebar";
import { AgentHeader } from "./Commun/AgentHeader";

import { AgentBookingCancle, Agentbookingpdf, AgentCancelReason, agentPropertylist, getagentBookingList } from "../Services/Service";

// import ReactDOMServer from "react-dom/server";
import html2pdf from "html2pdf.js";
// import AgentBookingVoucher from "./AgentBookingVoucher";
import swal from "sweetalert";



export const AgentBookingList = () => {
    const [bookingList, setBookingList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cancelCodes, setCancelCodes] = useState([]);
    const [selectedCode, setSelectedCode] = useState("");
    const [cancelReason, setCancelReason] = useState("");
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [properties, setProperties] = useState([]);
    const [selectedPID, setSelectedPID] = useState("");



    // Property name Dropdown
    useEffect(() => {
        const FetchPropertyname = async () => {
            setLoading(true);
            try {
                const result = await agentPropertylist();
                setProperties(result);

                // Default select first property if available
                if (result.length > 0) {
                    setSelectedPID(result[0].PropertyID);
                }
            } catch (error) {
                console.log("Property not get from api", error);
            } finally {
                setLoading(false);
            }
        };
        FetchPropertyname();
    }, []);


    useEffect(() => {
        if (!selectedPID) return;
        const GetBookinglist = async () => {
            setLoading(true);
            try {

                const result = await getagentBookingList(selectedPID);
                setBookingList(result || []);
            } catch (error) {
                console.log("Error getting booking list", error);
            } finally {
                setLoading(false);
            }
        };
        GetBookinglist();
    }, [selectedPID]);


    useEffect(() => {
        if (bookingList.length > 0 && window.$) {
            const table = window.$('.basic-datatables');

            // Check if already initialized
            if (window.$.fn.DataTable.isDataTable(table)) {
                table.DataTable().destroy(); // Destroy previous instance
            }

            setTimeout(() => {
                table.DataTable(); // Initialize new DataTable
            }, 0);
        }
    }, [bookingList]);




    // const handleVoucherPDF = async (booking) => {
    //     setLoading(true);
    //     try {
    //         const voucherData = await AgentVoucher(booking.BONRESID);

    //         if (!voucherData) {
    //             alert("Unable to fetch voucher details");
    //             return;
    //         }

    //         const voucherHTML = ReactDOMServer.renderToString(
    //             <AgentBookingVoucher data={voucherData} />
    //         );

    //         const opt = {
    //             margin: 0,
    //             filename: `BookingVoucher_${booking.BONRESID}.pdf`,
    //             image: { type: "jpeg", quality: 0.98 },
    //             html2canvas: { scale: 2 },
    //             jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
    //         };

    //         html2pdf().set(opt).from(voucherHTML).save();
    //     } catch (error) {
    //         console.error("Error generating voucher PDF:", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const random = Math.floor(Math.random() * 1000) + 1;

    const handleVoucherPDF = async (booking) => {
        setLoading(true);
        try {
            // 1. Get voucher data from API
            const voucherData = await Agentbookingpdf(booking.BONRESID);
            if (!voucherData) {
                alert("Unable to fetch voucher details");
                return;
            }

            const guest = voucherData.Table?.[0] || {};
            const room = voucherData.Table1?.[0] || {};
            const hotel = voucherData.Table3?.[0] || {};
            const BookingID = voucherData.Table4?.[0] || {};
            const bookingCommentObj = guest.BookingComment ? JSON.parse(guest.BookingComment)[0] : {};
            const bookingComment = bookingCommentObj?.BookingComment || "";

            const propertyId = Number(localStorage.getItem("AgentPropertyID"));

            let filePath = "";

            if (propertyId === 27) filePath = "/Voucher Templates/Uday_Palace_27.html?v=" + random;
            else if (propertyId === 25) filePath = "/Voucher Templates/Haword_Johnson_25.html?v=" + random;
            else if (propertyId === 26) filePath = "/Voucher Templates/Neemaya_26.html?v=" + random;
            else if (propertyId === 29) filePath = "/Voucher Templates/Bhairavgarh_Palace_29.html?v=" + random;
            else if (propertyId === 30) filePath = "/Voucher Templates/The_Chinar_Resort_30.html?v=" + random;
            else if (propertyId === 31) filePath = "/Voucher Templates/Ramada_Indor_31.html?v=" + random;
            else {
                alert("Voucher template not found for this property");
                return;
            }

            // 4. Fetch the HTML template
            const response = await fetch(filePath);
            if (!response.ok) {
                alert("Failed to load voucher template");
                return;
            }
            let templateHTML = await response.text();

            // 5. Replace placeholders with actual data
            templateHTML = templateHTML
                .replace(/{{Title}}/g, guest.Title || "")
                .replace(/{{FirstName}}/g, guest.FirstName || "")
                .replace(/{{LastName}}/g, guest.LastName || "")
                .replace(/{{BookingDate}}/g, guest.BookingDate || "")
                .replace(/{{RoomName}}/g, room.RoomName || "")
                .replace(/{{MealPlan}}/g, room.MeelPlan || "")
                .replace(/{{CheckInDate}}/g, room.CheckInDate || "")
                .replace(/{{CheckOutDate}}/g, room.CheckOutDate || "")
                .replace(/{{Nights}}/g, room.Nights || "")
                .replace(/{{Travellers}}/g, room.Travellers || "")
                .replace(/{{RoomRate}}/g, room.RoomRate || "0")
                .replace(/{{ExtraBedAmount}}/g, room.ExtraBedAmount || "0")
                .replace(/{{TotalAfterTax}}/g, BookingID.TotalAfterTax || "0")
                .replace(/{{BONRESID}}/g, BookingID.BONRESID || "")
                .replace(/{{PMSRESID}}/g, BookingID.PMSRESID || "")
                .replace(/{{PropertyLogo}}/g, hotel.PropertyLogo || "")
                .replace(/{{DisplayName}}/g, hotel.DisplayName || "")
                .replace(/{{Address}}/g, hotel.Address || "")
                .replace(/{{HotelPhone}}/g, hotel.HotelPhone || "")
                .replace(/{{HotelMobile}}/g, hotel.HotelMobile || "")
                .replace(/{{HotelEmail}}/g, hotel.HotelEmail || "")
                .replace(/{{WebsiteList}}/g, hotel.WebsiteList || "")
                .replace(/{{BookingComment}}/g, bookingComment);
            // 6. Generate PDF
            const opt = {
                margin: 0,
                filename: `BookingVoucher_${booking.BONRESID}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
            };

            html2pdf().set(opt).from(templateHTML).save();
        } catch (error) {
            console.error("Error generating voucher PDF:", error);
            alert("Error generating PDF");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchCancelReason = async () => {
            try {
                const propertyID = localStorage.getItem("AgentPropertyID");
                const result = await AgentCancelReason(propertyID);
                console.log("reason data", result);
                setCancelCodes(result || []);
            }
            catch (error) {
                console.log("error fetching cancel resons in Booking list page", error);
            }
        }
        fetchCancelReason();
    }, []);

    const handleCodeChange = (e) => {
        const code = e.target.value;
        setSelectedCode(code);

        const selected = cancelCodes.find((c) => c.Code === code);
        if (selected) {
            setCancelReason(selected.Description);
        } else {
            setCancelReason("");
        }
    };

    // reset form
    const resetCancelForm = () => {
        setSelectedCode("");
        setCancelReason("");
        setSelectedBooking(null);
    };

    // booking cancle
    const handleCancelBooking = async (booking) => {

        if (!selectedCode) {
            alert("Please select a cancellation code.");
            return;
        }

        if (!cancelReason) {
            alert("Please enter a reason.");
            return;
        }


        const PropertyID = localStorage.getItem("AgentPropertyID");

        setLoading(true);
        try {
            const result = await AgentBookingCancle(booking.BONRESID, PropertyID, selectedCode, cancelReason);

            if (result && result.BONRESID) {
                swal("Booking cancelled successfully!", {
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            className: "btn btn-success",
                        },
                    },
                }).then(() => {

                    const modal = window.bootstrap.Modal.getInstance(
                        document.getElementById("Cancel-Booking-Resion")
                    );
                    if (modal) modal.hide();

                    resetCancelForm(); // reset fields
                });

                // Table update: remove cancelled booking ya fetch list again
                setBookingList((prev) =>
                    prev.map((b) =>
                        b.BONRESID === booking.BONRESID ? { ...b, BookingStatus: "Cancelled" } : b
                    )
                );

            } else {
                alert(result?.message || "Failed to cancel booking");
            }
        } catch (error) {
            console.error(error);
            alert("Error cancelling booking");
        } finally {
            setLoading(false);
        }

    };

    return (
        <>

            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x" role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <AgentSidebar />
                <div className="main-panel">
                    <AgentHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-sm-5">
                                    <div className="input-block mb-3">
                                        <select
                                            className="form-control form-select"
                                            value={selectedPID}
                                            onChange={(e) => setSelectedPID(e.target.value)}
                                        >
                                            {properties.map((property) => (
                                                <option key={property.PropertyID} value={property.PropertyID}>
                                                    {property.PropertyName}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Agent Booking List</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table
                                                    // id="basic-datatables"
                                                    className="display table table-striped table-hover basic-datatables" style={{ whiteSpace: "nowrap" }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>sr#</th>
                                                            <th>Bon ref. id</th>
                                                            <th>pms id</th>
                                                            <th>check-in</th>
                                                            <th>check-out</th>
                                                            <th>guest info</th>
                                                            <th>payment</th>
                                                            <th>status</th>
                                                            <th>book on</th>
                                                            <th>action</th>

                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {bookingList.length > 0 ? (
                                                            bookingList.map((booking, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{booking.BONRESID || "N/A"}</td>
                                                                    <td>{booking.PMSRESID || "N/A"}</td>
                                                                    <td>

                                                                        {booking.CheckInDate || "N/A"}

                                                                    </td>
                                                                    <td>
                                                                        {booking.CheckOutDate || "N/A"}


                                                                    </td>
                                                                    <td>{booking.GuestName || "N/A"}</td>
                                                                    <td>
                                                                        ₹{booking.TotalPayment || 0}
                                                                        <div>
                                                                            {" "}
                                                                            <span
                                                                                className={
                                                                                    booking.PaymentStatus === "Paid"
                                                                                        ? "text-success"
                                                                                        : booking.PaymentStatus === "Pending"
                                                                                            ? "text-warning"
                                                                                            : "text-secondary"
                                                                                }
                                                                            >
                                                                                {booking.PaymentStatus || "N/A"}
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span
                                                                            className={`badge 
                                                                                 ${booking.BookingStatus === "Confirmed"
                                                                                    ? "bg-success"
                                                                                    : booking.BookingStatus === "Pending"
                                                                                        ? "bg-warning text-dark"
                                                                                        : booking.BookingStatus === "Cancelled"
                                                                                            ? "bg-danger"
                                                                                            : "bg-secondary"}`}
                                                                        >
                                                                            {booking.BookingStatus || "N/A"}
                                                                        </span>
                                                                    </td>
                                                                    <td>{booking.BookingDate || "N/A"}</td>
                                                                    <td className="text-center">
                                                                        <div className="dropdown dropdown-action">
                                                                            <a
                                                                                href="/"
                                                                                className="action-icon"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                            </a>
                                                                            <div className="dropdown-menu dropdown-menu-right">
                                                                                {/* <button className="dropdown-item">
                                                                                    <i className="fas fa-edit me-2"></i>
                                                                                    Modify
                                                                                </button > */}
                                                                                {booking.BookingStatus !== "Cancelled" && (
                                                                                    // <button className="dropdown-item" type='button' onClick={() => handleCancelBooking(item)}><i className='fas fa-ban me-1'></i> Cancelled </button>
                                                                                    <button type="button" className="dropdown-item" data-bs-toggle="modal"
                                                                                        data-bs-target="#Cancel-Booking-Resion" onClick={() => {
                                                                                            setSelectedBooking(booking); setSelectedCode(""); // reset code
                                                                                            setCancelReason("");
                                                                                        }} ><i className='fas fa-ban me-2'></i>Cancelled</button>
                                                                                )}
                                                                                <button className="dropdown-item" onClick={() => handleVoucherPDF(booking)}>
                                                                                    <i className="fas fa-sticky-note me-2"></i>
                                                                                    Booking Voucher
                                                                                </button>
                                                                                {/* <button className="dropdown-item" o>
                                                                                    <i className="fas fa-sticky-note me-2"></i>
                                                                                    Booking Voucher
                                                                                </button> */}
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10" className="text-center">
                                                                    No bookings found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="modal fade"
                                id="Cancel-Booking-Resion"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title" id="exampleModalLabel">
                                                Booking Cancel
                                            </h4>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">

                                            <div className="mb-3">
                                                <label className="col-form-label">Code:</label>
                                                <select className="form-control form-select" value={selectedCode}
                                                    onChange={handleCodeChange}>
                                                    <option>Select Code</option>
                                                    {cancelCodes.map((c) => (
                                                        <option key={c.Code} value={c.Code}>
                                                            {c.Code}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="" className="col-form-label">
                                                    Cancel Reason:
                                                </label>
                                                <textarea className="form-control" value={cancelReason}
                                                    onChange={(e) => setCancelReason(e.target.value)} />
                                            </div>

                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" onClick={() => handleCancelBooking(selectedBooking)} className="btn btn-danger">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
              
            </div>
        </>
    )
}
